(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairCommentsController', PhysicalFairCommentsController);
    PhysicalFairCommentsController.$inject = ['$timeout', 'ExpoService', 'CitiesByExpoService', 'PhysicalFairService'];
    function PhysicalFairCommentsController($timeout, ExpoService, CitiesByExpoService, PhysicalFairService) {
        var vm = this;

        vm.flag                  = false;
        vm.commentsResult         = [];
        vm.expoSelected          = [];
        vm.cities                = [];
        vm.i                     = -1;
        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getByFilter           = getByFilter;
        vm.citySelected          = [];
        vm.citySelectedCSV       = '';
        vm.expoSelectedCSV       = '';

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;
        vm.downloadCSV           = downloadCSV;

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                 vm.expo = response.data;
            }).catch(function(err) {
            });
        }

        function selectCitiesByExpo () {
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.cities = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            if(typeof vm.citySelected !== 'undefined') {
                vm.query['location_id'] = vm.citySelected.expos_locations_id;
            }
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            /* Load variables to CSV */
            vm.citySelectedCSV  = vm.citySelected.expos_locations_id;
            vm.expoSelectedCSV  = vm.expoSelected.id;
            PhysicalFairService.getByFilterComments(vm.query).then(function(response){
                vm.commentsResult = response.data.data;
                vm.flag = true;
                if(vm.commentsResult.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }

                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err){
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function downloadCSV () {
            vm.query = {};

            vm.query['expo_id'] = vm.expoSelectedCSV;
            if(typeof vm.citySelectedCSV !== 'undefined') {
                vm.query['location_id'] = vm.citySelectedCSV;
            }

            PhysicalFairService.downloadReportCommentsCSV(vm.query).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'report_comments.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function(data, status, headers, config) {
                // handle error
            });
        }
        activate();
    }
})();